module.exports = __webpack_public_path__ + "img/PowerRailUnAssign.d146fcce.svg";